import { RestClient } from '@/api/rest-client'
import { Offer } from '@/api/model/offer'
import { User } from '@/api/model/user'

export class OfferClient extends RestClient<Offer> {
    collectionName = 'offers'
    parseData = Offer.fromData

    async requestOffer(data: { offer: Offer, user: User }): Promise<void> {
        await this.client.post(`${this.basePath}/${this.collectionName}`, {
            offer: data.offer,
            user: data.user.resourceIdentifier,
        })
    }
}
